export default "__VITE_ASSET__BSlOFMO9__"